import React from 'react';
import useToken from '../hooks/useToken';
import useUser from '../hooks/useUser';
import { useState, useEffect, useMemo, useRef } from 'react';
import { SERVER_API_URL } from '../config/Constants'
import Loading from '../components/Loading'
import ImageBackground from '../components/ImageBackground'
import { HEADER_HEIGHT } from '../config/Constants'
import GameUtils from '../utils/gameUtils'
import UserService from '../services/UserService'
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Chessboard } from "react-chessboard";
import { Chess } from 'chess.js';
import PiecesImg from '../graphics/pieces'
import Utils from '../utils/utils';
//import Chess from '../utils/chess';

//import { Chess } from '../../node_modules/chess.js/dist/cjs/chess.js';
import SoundDing from '../sounds/ding.mp3';
import SoundFart from '../sounds/fart.mp3';
import SoundClick from '../sounds/click.wav';
import { getBestMove } from '../utils/ai'
import Timer from "../components/Timer"
import Toggle from "react-toggle";
import "react-toggle/style.css"
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import strings from "../config/strings";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ListGroup from 'react-bootstrap/ListGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faVolumeOff, faGear, faVolumeHigh, faLightbulb, faPause, faEye, faHourglassHalf, faMessage, faEarthAsia, faRobot, faBackwardStep, faForwardStep, faTrophy, faThumbsDown, faBan, faUserNinja, faUserAstronaut, faUserGraduate, faUserDoctor, faUserInjured, faUserSecret, faUserShield, faBook, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import HelpModal from '../components/HelpModal';
import PauseModal from '../components/PauseModal';
import GameAvailable from '../components/GameAvailable';
import SimpleAlert from '../components/SimpleAlert';
import cable from '../channels/cable'
import GameChannel from '../channels/GameChannel'
import LobbyChannel from '../channels/LobbyChannel'
import Countdown from '../components/Countdown'
import ChatModal from '../components/ChatModal'
import ChatBubble from '../components/ChatBubble';
import BotSettingsModal from '../components/BotSettingsModal'
import AccountModal from '../components/AccountModal';
import { registerAnonymousUser } from './Login';
import { useTranslation } from 'react-i18next';
import { shouldWarnAboutKingCapture } from '../utils/kingCaptureWarning';
import { findBookMove } from '../utils/bookMoves';
import { hasFourfoldRepetition } from '../utils/repetition';
import { clickMoveAction } from '../utils/clickMove';

//import { useCable } from '../contexts/CableProvider';
//import { useChannel } from '@aersoftware/react-use-action-cable';
import {
  ScrollView,
  View,
  TextInput,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  //Alert,
  FlatList,
  ActivityIndicator,
  Dimensions
} from 'react-native';

const PIECES_TAKEN_HEIGHT = 40

export default function Game() {
  const { t } = useTranslation();
  //const actionCable = useCable();
  //const { subscribe, unsubscribe, send } = useChannel(actionCable)

  const navigate = useNavigate();
  const audioFart = useMemo(() => new Audio(SoundFart), []);
  const audioDing = useMemo(() => new Audio(SoundDing), []);
  const audioClick = useMemo(() => new Audio(SoundClick), []);
  const { token, setToken } = useToken();
  const { user, setUser } = useUser();
  const [loading, setLoading] = useState(true);
  const [isBotGame, setIsBotGame] = useState(false);
  const [loadingAI, setLoadingAI] = useState(false);
  const [checkAlertTarget, setCheckAlertTarget] = useState([]);
  const [checkAlertMessage, setCheckAlertMessage] = useState("");
  const checkAlertTimerRef = useRef(null);
  const [bookMove, setBookMove] = useState(null);
  const bookMoveTimerRef = useRef(null);

  const showCheckWarning = (attackers, errorType) => {
     setCheckAlertTarget(attackers || []);
     if (errorType === 'invalid_push_back') {
         setCheckAlertMessage('You cannot move back immediately to your previous position after having been pushed back');
     } else {
         setCheckAlertMessage(errorType === 'already_in_check' ? 'You are in check' : 'That would put your king in check');
     }
     if (checkAlertTimerRef.current) clearTimeout(checkAlertTimerRef.current);
     checkAlertTimerRef.current = setTimeout(() => {
         setCheckAlertTarget([]);
         setCheckAlertMessage('');
     }, 3000);
  }

  const showBookMove = (move) => {
    if (bookMoveTimerRef.current) clearTimeout(bookMoveTimerRef.current);
    setBookMove(move);
    bookMoveTimerRef.current = setTimeout(() => {
      setBookMove(null);
    }, 4000);
  }

  const [showAccount, setShowAccount] = useState(!localStorage.getItem('user'));
  const [showHelp, setShowHelp] = useState(false);
  const [showPause, setShowPause] = useState(false);
  const [showGameAv, setShowGameAv] = useState(false);
  const [times, setTimes] = useState(false);
  //const [isWhite, setIsWhite] = useState(false);
  const [soundDisabled, setSoundDisabled] = useState(localStorage.getItem('soundDisabled') == 'true' ? true : false);
  const [myTurn, _setMyTurn] = useState(false);
  const [selectedSquare, setSelectedSquare] = useState(null);
  const [debugHistory, setDebugHistory] = useState(localStorage.getItem('user') ? 'user_id:' + JSON.parse(localStorage.getItem('user')).id + '\n' : '');
  const [lastMove, setLastMove] = useState([]);
  const [lastMoveAsString, setLastMoveAsString] = useState('');
  //const [fenBeforeMyMove, setFenBeforeMyMove] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  const loadingGame = useRef(false)
  const myTurnRef = useRef(false)
  const fenBeforeMyMoveRef = useRef(false)
  const gameUtilsRef = useRef(false)
  const isWhiteRef = useRef(false);
  const isConnected = useRef(false);
  const tryToConnectAt = useRef(0);
  const lastPingAt = useRef(0);
  const lastInteractionAt = useRef(0);
  const needRefresh = useRef(false);
  const gameHistory = useRef([]);
  const botPositionHistoryRef = useRef([]);
  const botPositionHistoryLoadedRef = useRef(false);
  const currentHistoryPos = useRef(-1);
  const piecesTakenRef = useRef(null)
  const [gameToJoin, setGameToJoin] = useState(null);
  const haveSentOnExpire = useRef(false)
  const timerRef = useRef(null)
  const lobbyConnected = useRef(false)
  const [alertContent, setAlertContent] = useState(false)
  const [alertAskJoinContent, setAskJoinAlertContent] = useState(false)
  const [rematchState, setRematchState] = useState(null)
  const rematchTimeoutRef = useRef(null)
  const [rematchExpired, setRematchExpired] = useState(false)
  const rematchVisibleTimeoutRef = useRef(null)
  const [ratingState, setRatingState] = useState(null)
  const [opponentRatingMessage, setOpponentRatingMessage] = useState(null)
  const [gameFinished, setGameFinished] = useState(false)
  const timeOffset = useRef(0)
  const timerCancelRef = useRef(null)
  const timerCheckConfirmMove = useRef(null)
  const timerJoinAskedRef = useRef(null)
  const timerGameAvailableRef = useRef(null)
  const opponentRef = useRef(null)
  const gameRef = useRef(null)
  const timerCheckIsUpToDateRef = useRef(null)
  const messageListRef = useRef([])

  const [showChat, setShowChat] = useState(false);
  const [friendshipStatus, setFriendshipStatus] = useState(null);
  const [hasNewMessage, setHasNewMessage] = useState(false);
  const [messageList, setMessageList] = useState([]);
  const [showChatBubbleMessage, setShowChatBubbleMessage] = useState('');
  const [showBotSettings, setShowBotSettings] = useState(false)
  const botLevel = useRef(3)
  const [gameInThePast, setGameInThePast] = useState(null)
  const [movesInThePast, setMovesInThePast] = useState(null)
  const fire = new Event('fire');
  const isInvitationUrl = useLocation().pathname.includes('/invitation');
  const [isInvitationPending, setIsInvitationPending] = useState(false);

  let { id } = useParams();
  let query = new URLSearchParams(useLocation().search);

  let paramIsBotGame = query.get("isBotGame");
  let paramWaitingForGameWithTime = query.get("waitingForGameWithTime");

  //const [ fen, setFen ] = useState(null);
  const [game, setGame] = useState(null);

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {

    if (paramIsBotGame)
      return


    const handleBeforeUnload = (event) => {
      // Custom behavior before the user leaves the page
      console.log('User is leaving the page');

      if (!gameFinished)
        GameUtils.leftGame(id)
      // If you want to show a confirmation dialog
      //   event.preventDefault();
      //  event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup the event listener on component unmount
    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    let interval = null;
    if (isInvitationPending && user && user.id) {
       interval = setInterval(() => {
         GameUtils.isReady(id).catch(e => console.error(e));
       }, 10000);
       GameUtils.isReady(id).catch(e => console.error(e));
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isInvitationPending, id, user]);


  const getRealTime = () => {
    return Date.now() - timeOffset.current
  }
  const setTimeOffset = (realTime) => {
    timeOffset.current = Date.now() - (realTime * 1000)
  }

  const saveToDebug = (txt, showTime = false) => {
    if (showTime) {
      var date = new Date();
      var hour = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      txt = hour + ':' + minutes + ':' + seconds + ' ' + txt;
    }
    setDebugHistory(prevDebugHistory => prevDebugHistory + txt + '\n')
    console.log(txt)
  }

  const recordBotPosition = (fen, movesVersion) => {
    if (!fen) return botPositionHistoryRef.current.map((entry) => entry.fen)

    const storageKey = `sumochess_bot_position_history_${id}`
    if (!botPositionHistoryLoadedRef.current) {
      botPositionHistoryLoadedRef.current = true
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '[]')
        if (Array.isArray(saved)) {
          botPositionHistoryRef.current = saved
            .filter((entry) => entry && typeof entry.fen === 'string')
            .slice(-512)
        }
      } catch (_) {
        botPositionHistoryRef.current = []
      }
    }

    const version = typeof movesVersion === 'string' ? movesVersion : ''
    const last = botPositionHistoryRef.current[botPositionHistoryRef.current.length - 1]
    if (!last || last.movesVersion !== version) {
      botPositionHistoryRef.current = [
        ...botPositionHistoryRef.current,
        { fen, movesVersion: version },
      ].slice(-512)
      localStorage.setItem(storageKey, JSON.stringify(botPositionHistoryRef.current))
    }

    return botPositionHistoryRef.current.map((entry) => entry.fen)
  }

  const persistBotRepetitionForfeit = () => {
    localStorage.setItem(`sumochess_bot_repetition_forfeit_${id}`, 'true')
    setLoadingAI(false)
    setGameFinished(true)
    showResult(true, false, 'bot_repetition')
  }

  const handleLastMove = (lastMoveStr) => {
    const moves = lastMoveStr.split(',')
    var array = []
    const lastMove = [moves[0], moves[1], 'blue']
    array.push(lastMove)
    if (moves.length > 2) {
      const pushedPiece = [moves[1], moves[2], 'red']
      array.push(pushedPiece)
    }


    setLastMove(array)
    setLastMoveAsString(lastMoveStr)

    return array ? array : null
  }

  const handleLobbyUpdate = (data) => {
    //  alert(JSON.stringify(data) + '>>' + JSON.stringify(user))
    // alert('handleReceived' + JSON.stringify(data) + '>>' + user.id)
    console.log(data) // response received from rails

    if (!data || !data.action || !user)
      return

    /*if (data.action == 'game_starts' && (data.player1_id == user.id || data.player2_id == user.id)) {
      // alert('nav')

      try {
        if (audioDing)
          audioDing.play()
      }
      catch (e) {
      }
      navigate("/game/" + data.game_id);
    }*/
    // alert(user.id + '  ' + data.user_id)
    // alert(JSON.stringify(data))
    /* if (data.action == 'game_starts' && (data.player1_id === user.id || data.player2_id === user.id)) {
       setAlertContent({
         variant: '',
         text: 'Someone wants to play with you',
         textColor: "text-warning",
         icon: faTrophy,
         buttonText: "Play (in new tab)",
         buttonAction: () => {

           window.open('/game/' + data.game_id, '_blank')
           setAlertContent(false)}
        })
     }*/
    if (data.action == 'ask_player_game' && data.asked_to === user.id) {
      setAskJoinAlertContent({
        variant: '',
        text: t('someone_wants_play'),
        textColor: "text-warning",
        icon: faTrophy,
        buttonText: t('play_new_tab'),
        buttonTimeOut: 15,
        buttonAction: () => {

          acceptGame({ id: data.lobby_id, user_id: data.user_id })
          //window.open('/game/' + data.game_id, '_blank')
          setAskJoinAlertContent(false)
        }
      })
      if (timerJoinAskedRef.current)
        clearTimeout(timerJoinAskedRef.current)
      timerJoinAskedRef.current = setTimeout(() => setAskJoinAlertContent(false), 15000)
    }

    if (data.action == 'game_starts' && gameToJoin && gameToJoin.unique_id == data.unique_id) {
      setGameToJoin(null)
    }

    if (data.action == 'game_new' && (data.time == paramWaitingForGameWithTime || paramWaitingForGameWithTime === -1 || data.time === -1)) {
      setGameToJoin(data)
      if (timerGameAvailableRef.current)
        clearTimeout(timerGameAvailableRef.current)

      timerGameAvailableRef.current = setTimeout(() => { setGameToJoin(null); }, 15000)
    }
  }


  useEffect(() => {
    if (!paramIsBotGame || !paramWaitingForGameWithTime) {
      return
    }
    const channel = new LobbyChannel({})


    // Subscribe to the server channel via the client.
    cable.subscribe(channel) // return channel itself for chaining



    // Handle incoming messages
    let unbindMessage = channel.on('message', msg => {
      // alert(JSON.stringify(msg))
      handleLobbyUpdate(msg)
      console.log(`${msg.name}: ${msg.text}`)
    }
    )


    // Cleanup function
    return () => {
      // Unsubscribe from the channel (results in a 'close' event)
      channel.disconnect()
      unbindMessage()
    }

  }, []);

  /*
  useEffect(() => {
    if (!paramIsBotGame || !paramWaitingForGameWithTime) {
      return
    }

    const subscription = consumer.subscriptions.create({
      channel: 'LobbyChannel',

    }, {
      connected: () => {
        lobbyConnected.current = true
      },
      disconnected: () => {

        },
      received: data => handleLobbyUpdate(data),
      ping: () => {  },
    })

    // Cleanup function
    return () => {
      //if (lobbyConnected.current) {
       // lobbyConnected.current = false
      // consumer.subscriptions.remove(subscription);
      //}
    }

  }, []);*/
  /*
    const lastMove () => {
      const moves = lastMoveAsString.split(',')
      var array = []
      const firstArrow = [moves[0], moves[1], 'blue']
      array.push(firstArrow)
      if (moves.length > 2) {
        const pushedPiece = [moves[1], moves[2], 'red']
        array.push(pushedPiece)
      }


     // setArrows(array)
     // setLastMoveAsString(lastMoveStr)

      return array ? array : null
    }*/

  const testBug = () => {
    var buggedGame = new Chess('N2P4/3r3p/5p2/2p1p3/5P2/4k1K1/6PP/7q w - - 0 31')
    var moves = buggedGame.moves({ verbose: true })
    for (var i = 0; i < moves.length; i++) {
      var child = moves[i]
      if (child.to.length !== 2) {
        console.log(child.before)
        console.log(child.after)
        alert('debug invalid to' + JSON.stringify(child))
      }
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    function handleMouseMove(event) {
      //console.log(`Mouse moved: X:${event.clientX}, Y:${event.clientY}`);
      lastInteractionAt.current = Date.now()
    }

    window.addEventListener('mousemove', handleMouseMove);

    // Be sure to remove event listener when the component unmounts
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount



  const playFart = () => {
    console.log("###### FAAAAAART ######")
    window.dispatchEvent(fire);
    try {
      if (audioFart && !soundDisabled)
        audioFart.play()
    }
    catch (e) {
    }
  }

  const onExpire = async () => {

    if (haveSentOnExpire.current)
      return
    await GameUtils.gameTimeout(id)
    setGameFinished(true)
    if (timerRef.current)
      clearTimeout(timerRef.current)
  }

  const confirmMove = async () => {
    await GameUtils.confirmMove(id)
  }

  const checkMoveConfirmed = async () => {
    await GameUtils.checkMoveConfirmed(id)
  }

  const handleRating = async (rating) => {
    try {
      setRatingState(rating)
      await GameUtils.rateOpponent(id, rating)
    } catch(e) {
      console.log(e)
    }
  }

  const renderRatingFooter = () => {
    return (
      <View style={{ width: '100%', marginTop: 24, paddingTop: 16, borderTopWidth: 1, borderTopColor: '#555' }}>
        {opponentRatingMessage && (
           <Text style={{ color: '#aaa', fontSize: 13, marginBottom: 12, fontStyle: 'italic', textAlign: 'center' }}>
             {opponentRatingMessage}
           </Text>
        )}
        {!ratingState ? (
          <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
            <Button variant="info" size="sm" onClick={() => handleRating('congrats')} style={{ marginRight: 10 }}>
              {t('congratulate_opponent')}
            </Button>
            <Button variant="danger" size="sm" onClick={() => handleRating('insult')}>
              {t('insult_mother')}
            </Button>
          </View>
        ) : (
          <View style={{ alignItems: 'center' }}>
            <Text style={{ color: ratingState === 'congrats' ? '#28a745' : '#dc3545', textAlign: 'center', fontSize: 14, marginBottom: friendshipStatus === 'none' && ratingState === 'congrats' ? 8 : 0 }}>
              {ratingState === 'congrats' ? t('galantry_reward') : t('rudeness_penalty')}
            </Text>
            {friendshipStatus === 'none' && ratingState === 'congrats' && (
              <Button variant="outline-success" size="sm" onClick={() => {
                UserService.requestFriend(opponentRef.current.id);
                setFriendshipStatus('pending');
              }}>
                {t('add_as_friend')}
              </Button>
            )}
          </View>
        )}
      </View>
    )
  }

  const handleRematch = async () => {
    try {
      setRematchState('waiting')
      if (rematchTimeoutRef.current) clearTimeout(rematchTimeoutRef.current)
      rematchTimeoutRef.current = setTimeout(() => setRematchState(null), 15000)
      
      await GameUtils.postRematch(id)
    } catch(e) {
      console.log(e)
    }
  }

  const handleResign = async () => {
    if (window.confirm(t('confirm_resign'))) {
      try {
        await GameUtils.resign(id)
        setShowBotSettings(false)
      } catch(e) {
        console.log(e)
      }
    }
  }

  const showResult = (won, onTime = false, reason = null) => {
    var text = won ? t('you_won') : t('you_lost')
    if (onTime) text += ' ' + t('on_time')
    else if (reason === 'resignation') text += won ? ' ' + t('by_resignation') : ' ' + t('you_resigned')
    else if (reason === 'bot_repetition') text += '. ' + t('bot_forfeited_repetition')

    //text += '\n. Like the game? Please upvote us on hacker news before it disappears in the sea of submissions!'

    if (rematchVisibleTimeoutRef.current) clearTimeout(rematchVisibleTimeoutRef.current)
    rematchVisibleTimeoutRef.current = setTimeout(() => setRematchExpired(true), 15000)

    if (!paramIsBotGame && opponentRef.current && user) {
      UserService.getFriendshipStatus(opponentRef.current.id).then(res => {
        setFriendshipStatus(res.data.status)
      }).catch(e => console.log(e))
    }

    const initialReferer = localStorage.getItem('initial_referer');
    const askedToUpvote = localStorage.getItem('asked_to_upvote');
    let isReddit = false;
    let isHN = false;
    if (initialReferer && !askedToUpvote) {
      isReddit = initialReferer.includes('reddit.com');
      isHN = initialReferer.includes('news.ycombinator.com');
    }

    if (isReddit || isHN) {
      localStorage.setItem('asked_to_upvote', 'true');
      const platform = isReddit ? 'reddit' : 'hn';
      setAlertContent({
        isUpvotePrompt: true,
        variant: won ? 'success' : 'danger',
        text: text + `\n\nDid you like it? Could you upvote us on the ${platform} thread? Pretty please \u{1F97A}`,
        textColor: won ? "text-warning" : "text-danger",
        icon: won ? faTrophy : faThumbsDown,
        noClose: true,
        buttonText: "Yes",
        buttonAction: () => {
          if (isHN) {
            window.location.href = 'https://news.ycombinator.com/from?site=sumochess.org';
          } else if (isReddit) {
            window.location.href = 'https://www.reddit.com/search/?q=sumochess.org&sort=new';
          } else {
            window.location.href = initialReferer;
          }
        },
        showButton2: true,
        buttonText2: "No",
        buttonAction2: () => {
          navigate('/');
          setAlertContent(false);
        },
        buttonVariant2: "secondary"
      });
      return;
    }

    setAlertContent({
      variant: won ? 'success' : 'danger',
      text: text,
      textColor: won ? "text-warning" : "text-danger",
      icon: won ? faTrophy : faThumbsDown,
      buttonText: t('go_to_lobby'),
      buttonAction: () => navigate('/')

    })
  }

  const handleReceived = (data) => {

    //attention cette function n'a pas acces aux dernieres updates, par exemple isWhite renverra false, car etait false au moment ou la fonction a ete creee
    saveToDebug('handleReceived' + JSON.stringify(data), true)
    //alert('handleReceived' + JSON.stringify(data))
    console.log(data) // response received from rails
    if (!data || !data.action) {
      saveToDebug('handleReceived bad data')
      return
    }

    if (data.action === 'rematch_requested') {
      if (data.by !== user.id) {
        setRematchState('requested')
        if (rematchTimeoutRef.current) clearTimeout(rematchTimeoutRef.current)
        rematchTimeoutRef.current = setTimeout(() => setRematchState(null), 15000)
      }
    }

    if (data.action === 'rematch_accepted') {
      if (rematchTimeoutRef.current) clearTimeout(rematchTimeoutRef.current)
      navigate('/game/' + data.new_game_id)
      window.location.reload()
    }

    if (data.action === 'opponent_rated' && data.by !== user.id) {
      if (data.type === 'congrats') setOpponentRatingMessage(t('opponent_congratulated'))
      if (data.type === 'insult') setOpponentRatingMessage(t('opponent_insulted'))
    }

    if (data.action == 'game_aborted') {

      clearInterval(timerCancelRef.current)
      if (rematchVisibleTimeoutRef.current) clearTimeout(rematchVisibleTimeoutRef.current)
      rematchVisibleTimeoutRef.current = setTimeout(() => setRematchExpired(true), 15000)
      
      setAlertContent({
        variant: 'success',
        text: t('game_aborted'),
        textColor: "text-warning",
        icon: faHourglassHalf,
        buttonText: t('go_to_lobby'),
        buttonAction: () => navigate('/'),
        noClose: true,
        aborted: true
      })
    }

    if (data.action == 'game_over') {
      setGameFinished(true)
      var isTimeOut = data.reason !== 'resignation'
      if (data.winner_id == user.id) {
        showResult(true, isTimeOut, data.reason)
      }
      else {
        showResult(false, isTimeOut, data.reason)
      }
    }

    if (data.action == 'new_message') {
      messageListRef.current = [...messageListRef.current, { user_id: data.user_id, message: data.message, created_at: data.created_at }]
      setMessageList(messageListRef.current)
      setHasNewMessage(true)
      setShowChatBubbleMessage(data.message)
      setTimeout(() => setShowChatBubbleMessage(''), 5000)

    }

    if (data.action == 'game_ready_to_start') {
      setIsInvitationPending(false);
      getGame(false);
    }

    if (data.action == 'game_move') {

      setIsInvitationPending(false);
      setGameInThePast(null)
      setMovesInThePast(null)
      if (data.whos_next === user.id && timerCheckIsUpToDateRef.current)
        clearTimeout(timerCheckIsUpToDateRef.current)

      if (
        data.whos_next === user.id
        && data.last_move
        && gameRef.current
      ) {
        const incomingMove = data.last_move.split(',');
        const completedPlyCount = data.moves
          ? data.moves.split(';').filter(Boolean).length
          : 0;
        const opponentBookMove = findBookMove({
          game: gameRef.current,
          sourceSquare: incomingMove[0],
          targetSquare: incomingMove[1],
          playerMoveNumber: Math.ceil(completedPlyCount / 2),
          positionHistory: gameHistory.current,
        });
        if (opponentBookMove) showBookMove(opponentBookMove);
      }

      var gameTmp = new Chess(data.board)
      setGame(gameTmp)
      gameRef.current = gameTmp

      var playedFart = false
      if (GameUtils.countTotalPieces(fenBeforeMyMoveRef.current) != GameUtils.countTotalPieces(data.board)) {
        playedFart = true
        playFart()
      }
      //setFenBeforeMyMove(data.board)
      fenBeforeMyMoveRef.current = data.board

      if (data.whos_next == user.id && !myTurnRef.current && !playedFart) {
        try {
          if (audioClick && !soundDisabled)
            audioClick.play()
        }
        catch (e) {
        }
      }
      var myTurnTmp = false
      if (data.whos_next == user.id)
        myTurnTmp = true
      else
        myTurnTmp = false
      setMyTurn(myTurnTmp)

      if (data.whos_next == user.id && data.isWinningMove) {
        //alert('You lost')
        showResult(false, false)

      }

      // Hack to bypass react-chessboard freeze bug when transitioning FEN and CustomArrows in the same render batch
      if (data.last_move) {
        setTimeout(() => {
            handleLastMove(data.last_move)
        }, 50)
      }

      if (timerRef.current)
        clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => onExpire(), data.player_turn_expires_at - getRealTime())
      setTimes({ non_player_time: data.non_player_time, player_turn_expires_at: data.player_turn_expires_at })
      console.log('resetting game utils after ws message', isWhiteRef.current)
      gameUtilsRef.current = new GameUtils(gameTmp, isWhiteRef.current, isBotGame, myTurnTmp, data.last_move)

      setHistory(data.board, data.moves)

      if (data.whos_next == user.id)
        confirmMove()
    }

  }



  const setHistory = (board, moves) => {
    gameHistory.current = gameUtilsRef.current.constructHistory(moves)
    currentHistoryPos.current = -1
    piecesTakenRef.current = gameUtilsRef.current.getPiecesTaken(board)
    //alert(JSON.stringify(piecesTakenRef.current))
  }


  const getGame = async (onlyRedrawIfChange = false) => {

    if (loadingGame.current)
      return


    loadingGame.current = true
    if (!onlyRedrawIfChange)
      setLoading(true)
    try {
      var res = await GameUtils.getGame(id)
    }
    catch (e) {
      // alert(e.message)
      console.error(e)
      loadingGame.current = false
      return
    }

    if (onlyRedrawIfChange && !paramIsBotGame) {

      //  console.log('checking if up to date', gameRef.current, gameRef.current ? gameRef.current.fen() : 'not set', res.data.board)
      if (gameRef.current && gameRef.current.fen() && res.data.board && gameRef.current.fen() != res.data.board) {
        console.log('need refresh')
        window.location.reload()
      }
      else
        timerCheckIsUpToDateRef.current = setTimeout(() => getGame(true), 20000)
      loadingGame.current = false
      return

    }

    if (res.data.server_time) {
      setTimeOffset(res.data.server_time)
    }
    setLoading(false)

    saveToDebug('getting game' + JSON.stringify(res.data))

    if (res.data.messages) {
      messageListRef.current = res.data.messages
      setMessageList(messageListRef.current)
      //alert(JSON.stringify(messageListRef.current))
    }
    const currentUserId = user ? user.id : -1;

    if (res.data.player1.id === currentUserId)
      opponentRef.current = res.data.player2
    else
      opponentRef.current = res.data.player1
    // alert('getting game' + JSON.stringify(res.data))
    var gameTmp = new Chess(res.data.board)
    setGame(gameTmp)
    gameRef.current = gameTmp
    fenBeforeMyMoveRef.current = res.data.board
    //setFenBeforeMyMove(res.data.board)

    const isBotGameTmp = !res.data.player2_id && res.data.is_invitation !== 1
    //alert(isBotGameTmp)
    if (!res.data.player2_id && res.data.is_invitation !== 1)
      setIsBotGame(isBotGameTmp)
    //alert(res.data.player1_color)

    const isWhiteTmp = (res.data.player1_id == currentUserId && res.data.player1_color == 0) || (res.data.player2_id == currentUserId && res.data.player1_color == 1)
    console.log("setting is white", isWhiteTmp)
    isWhiteRef.current = isWhiteTmp


    var myTurnTmp = res.data.whos_next === currentUserId
    setMyTurn(myTurnTmp)
    loadingGame.current = false


    if (res.data.last_move)
      handleLastMove(res.data.last_move)

    console.log('resetting game utils getGame')
    gameUtilsRef.current = new GameUtils(gameTmp, isWhiteTmp, isBotGameTmp, myTurnTmp)
    if (isBotGameTmp) recordBotPosition(res.data.board, res.data.moves)
    const botAlreadyForfeited = isBotGameTmp
      && localStorage.getItem(`sumochess_bot_repetition_forfeit_${id}`) === 'true'
    if (botAlreadyForfeited) persistBotRepetitionForfeit()
    // testBug()
    // return
    //alert(JSON.stringify(res.data))

    if (timerRef.current)
      clearTimeout(timerRef.current)

    if (res.data.player_turn_expires_at - getRealTime() > 0)
      timerRef.current = setTimeout(() => onExpire(), res.data.player_turn_expires_at - getRealTime())


    setTimes({ non_player_time: res.data.non_player_time, player_turn_expires_at: res.data.player_turn_expires_at })

    if (res.data.is_invitation === 1 && (!res.data.moves || res.data.moves.length === 0)) {
       const p1 = res.data.player1_ready_at;
       const p2 = res.data.player2_ready_at;
       if (p1 && p2 && Math.abs(p1 - p2) <= 30) {
           setIsInvitationPending(false);
       } else {
           setIsInvitationPending(true);
       }
    } else {
       setIsInvitationPending(false);
    }

    if (!botAlreadyForfeited && !myTurnTmp && isBotGameTmp && !loadingAI && res.data.player1_id == currentUserId) {

      setLoadingAI(true)
      setTimeout(() => {

        getAiMove(gameTmp, isWhiteTmp ? 'b' : 'w', res.data.last_move)
      }
        , 500)
    }
    setHistory(res.data.board, res.data.moves)

    handleGameCancelled(res.data)
    //alert(checkIfHasMoves(gameTmp, res.data.last_move, isWhiteTmp ? 'w' : 'b'))
  }

  /*useEffect(() => {
    subscribe({
      channel: 'GameChannel',
      game_id: id,
    }, {
      received: (data) => handleReceived(data),
      // Custom callbacks can be added for 'initialized', 'connected', and 'disconnected'
    })
    return () => {
      unsubscribe()
    }
  }, [])*/

  /*
    const connectToSocket = () => {

      const subscription = consumer.subscriptions.create({
        channel: 'GameChannel', game_id: id,

      }, {
        connected: () => {
          saveToDebug('socket connected')
          if (needRefresh.current) {
            getGame()
            needRefresh.current = false
          }
          isConnected.current = true
          lastPingAt.current = Date.now()
        },
        disconnected: () => {

          saveToDebug('socket disconnected')

          isConnected.current = false
          needRefresh.current = true


        },
        ping: () => { lastPingAt.current = Date.now() },
        received: data => handleReceived(data),
      })
      return subscription
    }*/

  const checkPing = () => {

    if (isBotGame) {
      console.log("not checking ping")
      return
    }

    console.log("checking ping", lastPingAt.current, Date.now())
    //if haven't had a ping since 10 s, we refresh the page
    if (lastPingAt.current < Date.now() - (10 * 1000)) {
      console.log('no ping, reloading')


      var obj = null
      var str = localStorage.getItem('reloadInfo')
      if (str)
        obj = JSON.parse(str)

      //resetting to 0
      if (obj && obj.lastReload && obj.lastReload < Date.now() - (15 * 60 * 1000)
        && lastInteractionAt.current > Date.now() - (10 * 60 * 1000)) {

        obj.lastReload = Date.now()
        obj.nbReload = 0
        localStorage.setItem('reloadInfo', JSON.stringify(obj))
        window.location.reload()
      }
      ////prevents flooding the server
      else if (obj && obj.nbReload && obj.nbReload > 5) {
        console.log('too many reloads')
      }
      else if (lastInteractionAt.current > Date.now() - (10 * 60 * 1000)) {
        if (!obj)
          obj = {}
        if (!obj.nbReload)
          obj.nbReload = 0
        obj.nbReload++
        obj.lastReload = Date.now()
        localStorage.setItem('reloadInfo', JSON.stringify(obj))
        window.location.reload()
      }


    }
  }

  useEffect(() => {
    // Event handler to set the focus state
    const handleVisibilityChange = () => {

      if (!document.hidden) {
        console.log('Page is focused');
        checkPing()
      } else {
        console.log('Page is not focused');
      }
    };

    // Add the event listener
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);


  const checkCancel = async () => {
    await GameUtils.gameCancelled(id)

    if (gameHistory.current && gameHistory.current.length > 2)
      clearInterval(timerCancelRef.current)
  }




  useEffect(() => {

    if (paramIsBotGame)
      return
    const timer = setInterval(() => checkPing(), 10000)


    // Cleanup function
    return () => {
      clearInterval(timer);
    }
  }, []);

  useEffect(() => {


    // Cleanup function
    return () => {
      if (timerCancelRef.current)
        clearInterval(timerCancelRef.current);
    }

  }, []);

  const handleGameCancelled = (game) => {
    if (paramIsBotGame)
      return

    if (timerCancelRef.current)
      clearInterval(timerCancelRef.current)
    if (gameHistory.current && gameHistory.current.length < 2) {
      timerCancelRef.current = setInterval(() => checkCancel(), 10000)
    }
  }


  useEffect(() => {

    if (paramIsBotGame)
      return

    const channel = new GameChannel({ game_id: id })


    // Subscribe to the server channel via the client.
    cable.subscribe(channel) // return channel itself for chaining

    // Handle incoming messages
    let unbindMessage = channel.on('message', msg => {
      // alert(JSON.stringify(msg))
      handleReceived(msg)
      console.log(`${msg.name}: ${msg.text}`)
    }
    )


    let unbindPing = cable.on('keepalive', msg => {

      if (msg && typeof msg === 'number') {
        setTimeOffset(msg)
      }
      lastPingAt.current = Date.now()
    })
    // Or subscription close events


    // Cleanup function
    return () => {
      // Unsubscribe from the channel (results in a 'close' event)
      channel.disconnect()
      unbindMessage()
      unbindPing()
    }

  }, []);

  /*
    useEffect(() => {


      const subscription = connectToSocket()


      // Cleanup function
      return () => {
        if (isConnected.current) {
          isConnected.current = false
         consumer.subscriptions.remove(subscription);
        }
      }
    }, []); // Notice the empty array here. This tells React to run the effect only once, thus mimicking componentDidMount.
  */
  useEffect(() => {
    getGame()
  }, []); // Notice the empty array here. This tells React to run the effect only once, thus mimicking componentDidMount.


  useEffect(() => {

    if (paramIsBotGame)
      return

    timerCheckIsUpToDateRef.current = setTimeout(() => getGame(true), 20000)



    // Cleanup function
    return () => {
      clearTimeout(timerCheckIsUpToDateRef.current);
    }
  }, []);

  const setMyTurn = (value) => {
    myTurnRef.current = value
    _setMyTurn(value)
    if (!value)
      setSelectedSquare(null)
  }



  const getAiMove = async (game, color, lastMoveAsString) => {

    if (hasFourfoldRepetition(
      botPositionHistoryRef.current.map((entry) => entry.fen),
      game.fen(),
    )) {
      persistBotRepetitionForfeit()
      return
    }

    const fenBefore = game.fen()
    var lastMoveHasPushed = null
    var lastMoveObj = null
    if (lastMoveAsString && lastMoveAsString.length > 0) {
      lastMoveObj = lastMoveAsString.split(',')
      if (lastMoveObj.length > 2)
        lastMoveHasPushed = { from: lastMoveObj[1], to: lastMoveObj[2] }

      //alert(lastMoveAsString + ' ' + JSON.stringify(lastMoveHasPushed))
    }

    const gameTmp = new Chess(game.fen())
    const bestMoves = getBestMove(gameTmp, color, botLevel.current, lastMoveHasPushed)
   // alert(JSON.stringify(bestMoves))
//return
    var bestMove = bestMoves[0]
    if (!bestMove) {
      //console.log("last move", lastMove)
      var moveLeft = gameUtilsRef.current.checkIfHasMoves(game, lastMoveAsString, color)
      if (!moveLeft) {
        //alert('You won against AI')
        setAlertContent({
          text: 'You won against AI!',
          textColor: "text-warning",
          icon: faRobot,
          buttonText: "Go to Lobby",
          buttonAction: () => navigate('/')

        })
        return
      }
      bestMove = moveLeft

    }
    setLoadingAI(false)
    saveToDebug('AI PLAYED ' + JSON.stringify(bestMoves))


    game = new Chess(fenBefore)

    const completedPlyCount = Math.max(0, gameHistory.current.length - 1);
    const aiPlayerMoveNumber = Math.floor(completedPlyCount / 2) + 1;
    let pendingAiBookMove = findBookMove({
      game,
      sourceSquare: bestMove.from,
      targetSquare: bestMove.to,
      playerMoveNumber: aiPlayerMoveNumber,
      positionHistory: gameHistory.current,
    });

    let hasMadeMove = await movePiece({
      from: bestMove.from,
      to: bestMove.to,
      promotion: "q",
    }, color, false, game, lastMoveAsString);


    //par exemple si on peut pousser la piece qui met en echec, mais ca remet en echec
    if (!hasMadeMove || hasMadeMove.error) {

      game = new Chess(fenBefore)
      var moveLeft = gameUtilsRef.current.checkIfHasMoves(game, lastMoveAsString, color)
      pendingAiBookMove = findBookMove({
        game,
        sourceSquare: moveLeft.from,
        targetSquare: moveLeft.to,
        playerMoveNumber: aiPlayerMoveNumber,
        positionHistory: gameHistory.current,
      });

      hasMadeMove = await movePiece({
        from: moveLeft.from,
        to: moveLeft.to,
        promotion: "q",
      }, color, false, game, lastMoveAsString);

    }

    if (hasMadeMove && !hasMadeMove.error && pendingAiBookMove) {
      showBookMove(pendingAiBookMove);
    }

    if (GameUtils.countTotalPieces(fenBefore) != GameUtils.countTotalPieces(game.fen())) {
      playFart()
    }
  }



  const toggleSound = () => {
    localStorage.setItem('soundDisabled', !soundDisabled ? 'false' : 'true')
    setSoundDisabled(!soundDisabled)
  }


  const renderTimerContent = (text1, text2) => {

    if (bookMove) {
      return (
        <ListGroup.Item
          className="bg-transparent"
          style={{ paddingTop: 8, paddingBottom: 8 }}>
          <View style={{
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <View style={{
              backgroundColor: '#FFFFFF',
              borderRadius: 8,
              paddingVertical: 8,
              paddingHorizontal: 12,
              marginRight: 12,
              flex: 1,
              boxShadow: '0 3px 10px rgba(0, 0, 0, 0.35)',
            }}>
              <Text style={{
                color: '#1D1D1D',
                fontSize: 15,
                fontWeight: 700,
                letterSpacing: 1,
                marginBottom: 3,
              }}>
                <FontAwesomeIcon icon={faBook} style={{ color: '#A1291F', fontSize: 16 }} />  Book move!
              </Text>
              <Text style={{
                color: '#A1291F',
                fontSize: 14,
                fontWeight: 700,
                letterSpacing: 0.5,
              }}>
                {bookMove.name}
              </Text>
            </View>
            {!isBotGame &&
              <View style={{ alignItems: 'flex-end' }}>
                <Text style={{
                  color: '#FFE492',
                  fontSize: 14,
                  fontWeight: 600,
                  letterSpacing: 1,
                  marginBottom: 8,
                }}>
                  {text1}
                </Text>
                <Text style={{
                  color: '#FFE492',
                  fontSize: 14,
                  fontWeight: 600,
                  letterSpacing: 1,
                }}>
                  {text2}
                </Text>
              </View>
            }
          </View>
        </ListGroup.Item>
      )
    }

    return (
      <ListGroup.Item
        className="d-flex justify-content-between align-items-center bg-transparent"
        style={{
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}>

        <View style={{
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',

        }}>
          <Text style={{
            color: "white",
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 1,
            marginBottom: 6

          }}><FontAwesomeIcon icon={faHourglassHalf} style={{ color: "#FFD145", fontSize: 16 }} />  Opponent Time:
          </Text>
          <Text style={{
            color: "#FFE492",
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 1,
            marginBottom: 6

          }}>
            {text1}
          </Text>
        </View>
        <View style={{
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',

        }}>
          <Text style={{
            color: "white",
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 1,
            marginBottom: 6,


          }}><FontAwesomeIcon icon={faHourglassHalf} style={{ color: "#FFD145", fontSize: 16 }} />  My Time:</Text>
          <Text style={{
            color: "#FFE492",
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 1,
            marginBottom: 6,

          }}>{text2}</Text>
        </View>
      </ListGroup.Item>
    )

  }

  const renderTimers = () => {
    if (gameFinished || (isBotGame && !bookMove)) {
      return null
    }
    if (!times) {

      console.log('no timers')
      return
    }

    return (
      <ListGroup
        style={{ backgroundColor: "rgba(0,0,0,0.15)", borderRadius: 8, marginTop: 12 }}
        variant="flush" defaultActiveKey="#link2">
        {
          !lastMoveAsString ? renderTimerContent(Utils.convertSecondsToTimerMinutes(times.non_player_time / 1000), Utils.convertSecondsToTimerMinutes(times.non_player_time / 1000)) :
            myTurn ? renderTimerContent(Utils.convertSecondsToTimerMinutes(times.non_player_time / 1000), <Timer getRealTime={getRealTime} timestamp={times.player_turn_expires_at} />) :
              renderTimerContent(<Timer getRealTime={getRealTime} timestamp={times.player_turn_expires_at} />, Utils.convertSecondsToTimerMinutes(times.non_player_time / 1000))
        }

      </ListGroup>
    )
  }

  async function movePiece(piece, colorToCheck, isTest = false, currentGame, lastMoveAsString, allowInvalidMoves = false) {

    const fenBefore = currentGame.fen()
    setLoading(true)
    const result = gameUtilsRef.current.makeAMove(piece, colorToCheck, isTest, currentGame, lastMoveAsString, showResult, allowInvalidMoves);
    // illegal move
    if (!result || result.error) {
      saveToDebug('invalid move')
      setLoading(false)
      return result;

    };
    //alert(JSON.stringify(result))



    var res = await GameUtils.makeMove(id, result.currentFen, result.lastMoveAsString, !result.hasMovesLeft ? true : false)
    
    
    console.log("Make move data", res)
    setLoading(false)
    if (res.data.error && res.data.error === 'timeout') {
      alert("You lost on time")
      setGameFinished(true)
      return
    }

    if (timerCheckConfirmMove.current)
      clearTimeout(timerCheckConfirmMove.current)

    if (!paramIsBotGame) {
      timerCheckConfirmMove.current = setTimeout(() => checkMoveConfirmed(), 12000)
      if (timerCheckIsUpToDateRef.current)
        clearTimeout(timerCheckIsUpToDateRef.current)
      timerCheckIsUpToDateRef.current = setTimeout(() => getGame(true), 20000)
    }

    var lastMoveObj = handleLastMove(result.lastMoveAsString)
    var tmpGame = new Chess(res.data.board)



    gameRef.current = tmpGame
    setGame(tmpGame)
    fenBeforeMyMoveRef.current = res.data.board
    //setFenBeforeMyMove(res.data.board)



    var myTurnTmp = false
    if (res.data.whos_next === user.id)
      myTurnTmp = true
    else
      myTurnTmp = false
    setMyTurn(myTurnTmp)
    console.log('resetting game utils after move', isWhiteRef.current)
    gameUtilsRef.current = new GameUtils(tmpGame, isWhiteRef.current, isBotGame, myTurnTmp, result.lastMoveAsString)


    if (isBotGame && GameUtils.countTotalPieces(fenBefore) != GameUtils.countTotalPieces(res.data.board)) {
      playFart()
    }
    if (isBotGame || paramIsBotGame) {
      setHistory(res.data.board, res.data.moves)
      setGameInThePast(null)
      setMovesInThePast(null)
      const botPositionHistory = recordBotPosition(res.data.board, res.data.moves)
      if (hasFourfoldRepetition(botPositionHistory, res.data.board)) {
        persistBotRepetitionForfeit()
        return true
      }
    }
    if (isBotGame && !res.data.whos_next) {
      setLoadingAI(true)
      setTimeout(() =>
        getAiMove(tmpGame, isWhiteRef.current ? 'b' : 'w', result.lastMoveAsString)
        , 500)
    }



    return true;
  }

  function isEnPassantMove(move) {
    const currentPiece = game.get(move.from);

    // Ensure the current piece is a pawn
    if (currentPiece.type !== 'p') return false;

    // En passant can only be a diagonal capture to an empty square
    if (move.to[0] === move.from[0]) return false;

    // The target square must be empty
    const pieceAtTarget = game.get(move.to);
    if (pieceAtTarget) return false;

    if (!lastMove)
      return false


    var lastMoveArray = lastMoveAsString.split(',')

    // Check if there was a last move and it was a pawn advancing two squares
    if (!lastMoveArray || lastMoveArray[0][1] === lastMoveArray[1][1]) return false;

    const lastMovedPiece = game.get(lastMoveArray[1]);


    if (!lastMovedPiece || lastMovedPiece.type !== 'p') return false;

    // Ensure the last lastMoveArray was two squares forward
    if (Math.abs(Number(lastMoveArray[0][1]) - Number(lastMoveArray[1][1])) !== 2) return false;

    // Ensure the capture is right after the opponent's pawn
    if (move.to[1] !== (currentPiece.color === 'w' ? '6' : '3')) return false;

    // Ensure that the last moved pawn is adjacent to the moving pawn's from-position
    if (Math.abs(move.from.charCodeAt(0) - lastMoveArray[1].charCodeAt(0)) !== 1) return false;

    return true;
  }


  async function completeDrop(sourceSquare, targetSquare) {

    const completedPlyCount = Math.max(0, gameHistory.current.length - 1);
    const pendingBookMove = findBookMove({
      game,
      sourceSquare,
      targetSquare,
      playerMoveNumber: Math.floor(completedPlyCount / 2) + 1,
      positionHistory: gameHistory.current,
    });

    const move = await movePiece({
      from: sourceSquare,
      to: targetSquare,
      promotion: "q",
    }, isWhiteRef.current ? 'w' : 'b', false, game, lastMoveAsString);
    // illegal move
    if (!move || move.error) {
      if (move && (move.error === 'check' || move.error === 'already_in_check' || move.error === 'invalid_push_back')) {
         showCheckWarning(move.attackers, move.error);
      }
      saveToDebug('invalid move')
      return false
    };

    if (pendingBookMove) showBookMove(pendingBookMove);

    return true;
  }

  async function onDrop(sourceSquare, targetSquare) {

    setSelectedSquare(null)

    if (!myTurn) {

      return
    }
    if (currentHistoryPos.current != -1 && gameHistory.current && currentHistoryPos.current < gameHistory.current.length - 1) {
      setGameInThePast(null)
      setMovesInThePast(null)
      currentHistoryPos.current = -1
      return
    }
    if (isEnPassantMove({ from: sourceSquare, to: targetSquare })) {
      //alert("YOU SHALL NOT EN PASSANT!!!")
      setAlertContent({
        text: 'YOU SHALL NOT EN PASSANT!!!',
        textColor: "text-danger",
        icon: faBan,

      })
      return
    }

    const kingCaptureWarningsShown = Number(localStorage.getItem('king_capture_warning_count')) || 0;
    if (kingCaptureWarningsShown < 2 && shouldWarnAboutKingCapture({
        game,
        user,
        sourceSquare,
        targetSquare,
        lastMoveAsString,
      })) {
      localStorage.setItem('king_capture_warning_count', String(kingCaptureWarningsShown + 1));
      setAlertContent({
        isKingCaptureWarning: true,
        text: t('king_capture_warning'),
        textColor: "text-warning",
        icon: faTriangleExclamation,
        closeText: t('cancel'),
        buttonText: t('continue'),
        buttonVariant: "warning",
        buttonAction: async () => {
          setAlertContent(false);
          await completeDrop(sourceSquare, targetSquare);
        },
      });
      return false;
    }

    return completeDrop(sourceSquare, targetSquare);
  }

  async function onSquareClick(square) {
    if (!myTurn || !game) {
      setSelectedSquare(null)
      return
    }

    if (currentHistoryPos.current != -1 && gameHistory.current && currentHistoryPos.current < gameHistory.current.length - 1) {
      setSelectedSquare(null)
      setGameInThePast(null)
      setMovesInThePast(null)
      currentHistoryPos.current = -1
      return
    }

    const action = clickMoveAction({
      selectedSquare,
      square,
      piece: game.get(square),
      playerColor: isWhiteRef.current ? 'w' : 'b',
    })

    setSelectedSquare(action.selectedSquare)
    if (action.move)
      await onDrop(action.move.from, action.move.to)
  }

  const mustShowBack = () => {

 //  if (gameHistory.current && gameHistory.current.length > 1 && (currentHistoryPos.current > 0 || currentHistoryPos.current === -1))
   //   return true
    if (gameHistory.current && gameHistory.current.length > 1 && (currentHistoryPos.current > 0 || currentHistoryPos.current === -1))
      return true
    return false
  }

  const mustShowNext = () => {

    if (currentHistoryPos.current != -1 && gameHistory.current && gameHistory.current.length >= 0 && currentHistoryPos.current < gameHistory.current.length - 1)
      return true
    return false
  }

  const historyNext = () => {

    if (currentHistoryPos.current == -1)
      currentHistoryPos.current = gameHistory.current.length - 1
    currentHistoryPos.current++

    // alert(JSON.stringify(gameHistory.current) + ' ' + currentHistoryPos.current)
    //if we got to the end

    var fen = gameHistory.current[currentHistoryPos.current].fen

    if (currentHistoryPos.current == gameHistory.current.length - 1) {

      if (myTurn && isWhiteRef.current && fen.indexOf(' w ') == -1) {
        fen = fen.replace(/ b /, ' w ')

      }
      else if (myTurn && !isWhiteRef.current && fen.indexOf(' b ') == -1) {
        fen = fen.replace(/ w /, ' b ')

      }

    }
    var gameTmp = new Chess(fen)

    if (currentHistoryPos.current == gameHistory.current.length) {
      setGame(gameTmp)
      setMovesInThePast(null)
    }
    else {
      setGameInThePast(gameTmp)
      setMovesInThePast(gameHistory.current[currentHistoryPos.current].moves)
    }

  }

  const historyBack = () => {

    if (currentHistoryPos.current == -1)
      currentHistoryPos.current = gameHistory.current.length - 1
    currentHistoryPos.current--

    //  alert(JSON.stringify(gameHistory.current) + ' ' + currentHistoryPos.current)

    var gameTmp = new Chess(gameHistory.current[currentHistoryPos.current].fen)
    setGameInThePast(gameTmp)
    setMovesInThePast(gameHistory.current[currentHistoryPos.current].moves)
  }

  const acceptGame = async (availableGame) => {
    setLoading(true)

    try {
      var res = await GameUtils.acceptGame(availableGame.id, availableGame.user_id)
      setLoading(false)
      if (res.data.error && res.data.error == 'already_started') {
        // alert("Another user already joined this game")
        setAlertContent({
          text: t('another_user_joined'),
          textColor: "text-danger",
          icon: faUserNinja,

        })

        setGameToJoin(null)
        return
      }
    }
    catch (e) {
      alert(e.message)
      setLoading(false)
    }
    // alert('going to game ' + JSON.stringify(data))
    navigate("/game/" + res.data.id);
    window.location.reload();
    // alert(JSON.stringify(res))

  }

  const renderPiecesTaken = (position) => {

    if (!piecesTakenRef.current)
      return null
    var piecesTaken = []

    for (var key in piecesTakenRef.current) {
      if ((key === key.toUpperCase() && position === 'top' && isWhiteRef.current)
        || (key === key.toLowerCase() && position === 'top' && !isWhiteRef.current)
        || (key === key.toUpperCase() && position === 'bottom' && !isWhiteRef.current)
        || (key === key.toLowerCase() && position === 'bottom' && isWhiteRef.current)) {
        piecesTaken.push({ piece: key, nb: piecesTakenRef.current[key] })
      }

    }
    //alert(JSON.stringify(piecesTaken))
    const prefix = (isWhiteRef.current && position === 'top') || (!isWhiteRef.current && position === 'bottom') ? 'w' : 'b'
    return (
      <View style={{ marginTop: 6, marginBottom: 6 }}>
        <View style={{ flexDirection: 'row' }}>
          {piecesTaken.map((piece) => {
            let piecesImgArr = [];
            for (var i = 0; i < piece.nb; i++) {
              ///alert(prefix + piece.piece)

              let ImageElement = PiecesImg[prefix + piece.piece.toUpperCase()];
              piecesImgArr.push(

                <div style={{ width: 25, height: 25 }}>
                  <svg viewBox="0 0 40 40" width='25' height='25'>
                    <g>
                      {ImageElement}
                    </g>
                  </svg>
                </div>
              )
            }

            return piecesImgArr
          })}
        </View>
      </View>
    )

  }


  const renderToolBox = () => {
    return (
      <ButtonToolbar aria-label="Toolbar with button groups">
        <ButtonGroup className="me-2" aria-label="First group">
          <ToggleButton
            id="toggle-check"
            type="checkbox"
            variant="dark"
            checked={soundDisabled}
            value="1"
            onChange={toggleSound}
          >
            <FontAwesomeIcon icon={soundDisabled ? faVolumeOff : faVolumeHigh} />
          </ToggleButton>

          <Button
            variant="dark"
            onClick={() => setShowPause(true)}

          >

            <FontAwesomeIcon icon={faPause} />
          </Button>
          {
            mustShowBack() &&
            <Button
              variant="dark"
              onClick={() => {

                historyBack()

              }
              }>
              <FontAwesomeIcon icon={faBackwardStep} />
            </Button>
          }

          {
            mustShowNext() &&
            <Button
              variant="dark"
              onClick={() => {
                historyNext()
              }
              }>
              <FontAwesomeIcon icon={faForwardStep} />
            </Button>
          }


        </ButtonGroup>
        <View style={{
          flexDirection: 'row',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',

        }}>
          <Text style={{
            color: "#fff",
            fontSize: 14,
            fontWeight: 300,
            letterSpacing: 2,
            marginBottom: 6


          }}>{myTurn ? t('my_turn') : t('not_my_turn')}</Text>
        </View>

        <ButtonGroup className="me-2" aria-label="Second group">
            <Button
              variant="dark"
              onClick={() => {
                setShowBotSettings(true)
              }
              }>
              <FontAwesomeIcon icon={faGear} />
            </Button>

          <Button
            variant="dark"
            onClick={() => {
              //window.dispatchEvent(fire);
              setShowHelp(true)
            }
            }>
            <FontAwesomeIcon icon={faLightbulb} />
          </Button>
        </ButtonGroup>
      </ButtonToolbar>
    )
  }

  const renderGameAvailable = () => {
    return (
      <Button variant="outline-warning" onClick={() => setShowGameAv(true)} className="mb-1 mt-2 ms-3 me-3" size="sm">
        <span style={{ flexDirection: 'row' }}>
          User Available! Elo: {gameToJoin.elo} <FontAwesomeIcon icon={faEye} style={{ color: "#FFD145", fontSize: 14 }} />  <Countdown time={15} />

        </span>
      </Button>


    )

  }

  const renderNormalGameInfos = () => {
    const icons = [faUserNinja, faUserAstronaut, faUserGraduate, faUserDoctor, faUserInjured, faUserSecret, faUserShield]
    var randomChosenIcon = icons[Math.floor(Math.random() * icons.length)]

    return (
      <View
        //className="mb-3"
        style={{
          flexDirection: isMobile ? "column" : 'row',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: isMobile ? 0 : 24,
          marginBottom: 12
        }}>

        {gameToJoin && renderGameAvailable()}
        {gameToJoin && <GameAvailable gameToJoin={gameToJoin} acceptGame={() => acceptGame(gameToJoin)} show={showGameAv} setShow={setShowGameAv} />}
        <View
          className="m-3"
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 6
          }}>
          <FontAwesomeIcon icon={randomChosenIcon} style={{ fontSize: 16, color: "#fff", }} />
          <Text style={{
            color: "#fff",
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 2,
            marginHorizontal: 8
          }}>{opponentRef.current.name} ({opponentRef.current.elo})</Text>
          <TouchableOpacity
            style={{
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onPress={() => { setShowChat(true); setHasNewMessage(false) }}>
            <FontAwesomeIcon icon={faMessage} style={{ fontSize: 16, color: hasNewMessage ? '#FECB2E' : "#fff", }} />
            {hasNewMessage && <Text style={{
              marginBottom: 3,
              marginLeft: 4,
              color: '#FECB2E',
              fontWeight: 900,
              letterSpacing: 2
            }}>(1)</Text>}
          </TouchableOpacity>

        </View>


      </View>
    )
  }


  const renderBotGameInfos = () => {
    return (
      <View
        //className="mb-3"
        style={{
          flexDirection: isMobile ? "column" : 'row',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: isMobile ? 0 : 24,
          marginBottom: 12
        }}>

        {gameToJoin && renderGameAvailable()}
        {gameToJoin && <GameAvailable gameToJoin={gameToJoin} acceptGame={() => acceptGame(gameToJoin)} show={showGameAv} setShow={setShowGameAv} />}
        <View
          className="m-3"
          style={{
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 6
          }}>
          <FontAwesomeIcon icon={faRobot} style={{ fontSize: 14, color: "#fff", }} />
          <Text style={{
            color: "#fff",
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: 2,
            marginHorizontal: 8
          }}>{t('bot_game')}</Text>
          {loadingAI && <ActivityIndicator size="small" color="#fff" />}
        </View>


      </View>
    )
  }
  var smallWidth = windowDimensions.width <= 480
  var prct = smallWidth ? 0.92 : 0.8
  var minSize = Math.min(windowDimensions.width, windowDimensions.height - HEADER_HEIGHT - (PIECES_TAKEN_HEIGHT * 2)) * prct
  minSize = minSize

  const boardSquareStyles = {}
  if (selectedSquare) {
    boardSquareStyles[selectedSquare] = {
      backgroundColor: 'rgba(255, 255, 0, 0.38)',
      boxShadow: 'inset 0 0 1px 4px rgba(255, 255, 0, 0.8)',
    }
  }
  checkAlertTarget.forEach((square) => {
    boardSquareStyles[square] = {
      ...boardSquareStyles[square],
      backgroundColor: 'rgba(255, 50, 50, 0.65)',
    }
  })

  //alert(JSON.stringify(lastMove))
  if (loading) {
    return (<Loading />)
  }
  return (


    <View
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        height: minSize + (PIECES_TAKEN_HEIGHT * 2)
      }}>
      <ChatModal show={showChat} gameId={id} messages={messageList} my_user_id={user?.id || -1} onHide={() => setShowChat(false)} />

      {showChatBubbleMessage && <ChatBubble message={showChatBubbleMessage} />}
      <HelpModal show={showHelp} onHide={() => setShowHelp(false)} />
      <PauseModal show={showPause} onHide={() => setShowPause(false)} onPause={() => alert('Pause not implemented yet, stay tuned.')} />
      {alertContent &&
        <SimpleAlert
          show={!!alertContent}
          onHide={() => setAlertContent(false)}
          alertContent={
            (paramIsBotGame || alertContent.isUpvotePrompt || alertContent.isKingCaptureWarning) ? alertContent : {
              ...alertContent,
              showButton2: !rematchExpired,
              buttonText2: rematchState === 'waiting' ? t('waiting_rematch') : 
                           rematchState === 'requested' ? t('accept_rematch') : t('rematch'),
              buttonVariant2: rematchState === 'requested' ? "success" : "warning",
              buttonAction2: handleRematch,
              buttonDisabled2: rematchState === 'waiting',
              customFooter: alertContent.aborted ? null : renderRatingFooter
            }
          }
        />
      }

      {alertAskJoinContent && <SimpleAlert
        show={alertAskJoinContent}
        onHide={() => setAskJoinAlertContent(false)}
        alertContent={alertAskJoinContent}
      />
      }

      <AccountModal
          mandatory={true}
          show={showAccount}
          onHide={() => setShowAccount(false)}
          onPlay={async (newUser) => {
              setShowAccount(false);
              setLoading(true);
              if (!token || !user || user.id === -1) {
                var data = await registerAnonymousUser(newUser)
                if (data && data.auth_token) {
                  localStorage.setItem('token', JSON.stringify(data.auth_token));
                  localStorage.setItem('user', JSON.stringify(data.user));
                  setToken(data.auth_token);
                  setUser(data.user);
                  window.location.reload();
                } else {
                  alert('An error occured');
                  setLoading(false);
                }
              }
          }}
      />
      <BotSettingsModal show={showBotSettings} onHide={() => setShowBotSettings(false)} isBotGame={paramIsBotGame} onResign={handleResign} onSelect={(value) => { botLevel.current = value; setShowBotSettings(false) }} />
      <View style={{ flexDirection: isMobile ? 'column' : 'row', alignItems: 'center' }}>
        <View
          style={{
            //width: "100%",
            width: minSize + 'px'
          }}>

          {isBotGame && renderBotGameInfos()}
          {!isBotGame && opponentRef.current && renderNormalGameInfos()}

          {renderPiecesTaken('top')}


          {renderToolBox()}

          {game &&
            <View style={{ position: 'relative' }}>
              <Chessboard
                key={gameInThePast ? gameInThePast.fen() : game.fen()}
                style={{
                  width: minSize + 'px',
                  height: minSize + 'px'
                }}
                id="BasicBoard"
                position={gameInThePast ? gameInThePast.fen() : game.fen()}
                onPieceDrop={onDrop}
                onSquareClick={onSquareClick}
                onPieceDragBegin={() => setSelectedSquare(null)}
                isDraggablePiece={(piece) => { return true }}
                customBoardStyle={{
                  boxShadow: "0 5px 25px rgba(0, 0, 0, 0.5)",
                  borderRadius: "6px",
                }}
                customDropSquareStyle={{ boxShadow: "inset 0 0 1px 4px rgba(255, 255, 0, 0.5)" }}
                customLightSquareStyle={{ backgroundColor: "#D1A038" }}
                customDarkSquareStyle={{ backgroundColor: "#A1291F" }}
                boardOrientation={isWhiteRef.current ? 'white' : 'black'}
                customArrows={movesInThePast ? movesInThePast : lastMove}
                customSquareStyles={boardSquareStyles}
              />
              {isInvitationPending && user ? (
                 <View style={{
                     position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, 
                     justifyContent: 'center', alignItems: 'center', 
                     backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 999,
                     borderRadius: 6
                 }}>
                     <ActivityIndicator size="large" color="#FFBA0E" style={{marginBottom: 20}} />
                     <Text style={{color: '#fff', fontSize: 18, textAlign: 'center', padding: 20}}>
                        {t('waiting_friend')}
                     </Text>
                     <Text style={{color: '#FFBA0E', fontSize: 16, marginBottom: 15, userSelect: 'all'}}>
                        {window.location.origin}/games/{id}/invitation
                     </Text>
                     <Button variant="warning" onClick={() => navigator.clipboard.writeText(window.location.origin + '/games/' + id + '/invitation')}>
                        {t('copy_url')}
                     </Button>
                 </View>
              ) : null}
              {checkAlertMessage !== "" ? (
                <View style={{ position: 'absolute', bottom: -5, left: 0, right: 0, alignItems: 'center', pointerEvents: 'none', zIndex: 100 }}>
                  <View style={{ backgroundColor: 'rgba(255,50,50,0.95)', padding: 12, borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.4)',  transform: [{ translateY: 30 }] }}>
                    <Text style={{ color: '#FFF', fontWeight: 'bold', fontSize: 16 }}>{checkAlertMessage}</Text>
                  </View>
                </View>
              ) : null}
            </View>}
          {renderPiecesTaken('bottom')}
          {renderTimers()}
        </View>
        <View>


        </View>
      </View>




    </View>



  );
}
